import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { useRole } from '../hooks/useRole';

function FilesTable() {
  const { getAccessTokenSilently } = useAuth0();
  const { isAdmin } = useRole();
  const [files, setFiles] = useState([]);
  const [downloadingFiles, setDownloadingFiles] = useState(new Set());
  const [notifying, setNotifying] = useState(false);
  const [notifySent, setNotifySent] = useState(false);

  useEffect(() => {
    const fetchFiles = async () => {
      const token = await getAccessTokenSilently();
      const endpoint = isAdmin ? "/api/mods" : "/api/users/mods";
      const register = "/api/users/me";
      const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}${register}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setFiles(res.data);
    };
    fetchFiles();
  }, [getAccessTokenSilently, isAdmin]);

  const download = async (id, type, filename) => {
    setDownloadingFiles(prev => new Set(prev).add(filename));
    try {
      const token = await getAccessTokenSilently();

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/download/${id}?type=${type}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const fileRes = await axios.get(data.url, {
        responseType: 'blob',
      });

      const safeFilename = filename || 'downloaded-file.fifamod';

      const blob = new Blob([fileRes.data], {
        type: fileRes.headers['content-type'] || 'application/octet-stream',
      });
      const url = window.URL.createObjectURL(blob);

      const linkEl = document.createElement('a');
      linkEl.href = url;
      linkEl.setAttribute('download', safeFilename);
      document.body.appendChild(linkEl);
      linkEl.click();
      linkEl.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
    } finally {
      setDownloadingFiles(prev => {
        const newSet = new Set(prev);
        newSet.delete(filename);
        return newSet;
      });
    }
  };

const notifyAdmin = async () => {
  setNotifying(true);
  try {
    const token = await getAccessTokenSilently();
    const userInfo = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/users/ping`, {
      username: userInfo.data.username,
      email: userInfo.data.email,
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setNotifySent(true);
  } catch (error) {
    console.error("Ping failed:", error);
  } finally {
    setNotifying(false);
  }
};

  return (
  <>
  <div className="overflow-x-auto">
    <table>
      <thead>
        <tr>
          <th>Game</th>
          <th>Mod Name</th>
          <th>Mod Version</th>
          <th>Game Version</th>
          <th>Squad File Download</th>
          <th>Mod Download</th>
        </tr>
      </thead>
      <tbody>
        {files.map((file, idx) => (
          <tr key={idx}>
            <td>{file.game}</td>
            <td>{file.modName}</td>
            <td>{file.modVersion}</td>
            <td>{file.gameVersion}</td>
            <td>
              {downloadingFiles.has(file.squadFileLink) ? (
                <>
                  <span className="spinner"></span> Downloading...
                </>
              ) : (
                <button
                  onClick={() => download(file.id, "SQUAD", file.squadFileLink)}
                  disabled={downloadingFiles.has(file.squadFileLink)}
                >
                  Download
                </button>
              )}
            </td>
            <td>
              {downloadingFiles.has(file.modLink) ? (
                <>
                  <span className="spinner"></span> Downloading...
                </>
              ) : (
                <button
                  onClick={() => download(file.id, "MOD", file.modLink)}
                  disabled={downloadingFiles.has(file.modLink)}
                >
                  Download
                </button>
              )}
            </td>

          </tr>
        ))}
      </tbody>
    </table>
    </div>

    <div className="mt-4">
      {notifySent ? (
        <p>Notification sent to admin.</p>
      ) : (
        <>
          <button
            onClick={notifyAdmin}
            disabled={notifying}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            {notifying ? "Sending..." : "Notify Admin"}
          </button>

          <p className="notify-warning">
            Only use this after making a new purchase. Do not click for any other
            reason. Incorrect use may result in your access being blocked,
            including access to all previously purchased mods.
          </p>
        </>
      )}
    </div>
      </>
  );
}

export default FilesTable;